import _ from 'lodash';
import { GetterTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { FiltersEvents, FiltersEventsState } from '@/models/states/filters-state.model';

export const getters: GetterTree<FiltersEventsState, RootState> = {
  getFilters(state): FiltersEvents {
    return _.cloneDeep(state.filters);
  },
};
